export default "__VITE_ASSET__CJiLJIqr__"